import { render } from "./PriceIndex.vue?vue&type=template&id=72a0c32b&ts=true"
import script from "./PriceIndex.vue?vue&type=script&lang=ts"
export * from "./PriceIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__